import { render, staticRenderFns } from "./expend-list.vue?vue&type=template&id=5dbbe076&scoped=true&"
import script from "./expend-list.vue?vue&type=script&lang=js&"
export * from "./expend-list.vue?vue&type=script&lang=js&"
import style0 from "./expend-list.vue?vue&type=style&index=0&id=5dbbe076&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbbe076",
  null
  
)

export default component.exports